// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"16":"smallProfileCard","136":"events","470":"navbar","715":"teachers-list","939":"google-map"}[chunkId] + "." + {"16":"06acb164","136":"235708a4","470":"4eba715c","715":"abb28ed5","939":"96acdefa"}[chunkId] + ".js";
};